import { Component, OnInit, Input, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { DetailProperty } from '../objects/DetailObject';
import { CountdownComponent } from 'ngx-countdown';
import { Observable, Subscription } from 'rxjs';
import * as moment from 'moment';
import { SessionTimerService } from '../services/session-timer.service';
import { Globals } from '../objects/Globals';
import { HeaderService } from '../services/header.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.css']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  
  @ViewChild('cd') private countdown: CountdownComponent;

  date: Date;
  days: number = 0;
  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;
  sub: Subscription;
  sub1: Subscription;
  warning:boolean = false;
  endDate: Date;
  title: string;
  subtitle: string;
  isMobile: boolean = false;

  constructor(private headerService: HeaderService, private deviceService: DeviceDetectorService) { 
    this.isMobile = deviceService.isMobile();
  }

  ngOnInit() {}

  @Input() leftTime: number;
  @Input() set setProperty(prop: DetailProperty){
    this.title = prop.PropertyDisplay.split('|')[0];
    this.subtitle = prop.PropertyDisplay.split('|')[1];
    if (prop.ParentPropertyValue){
      this.getDurationCountdown(prop);
    }
  }

  @Output() countdownEnd = new EventEmitter<boolean>();

  getDurationCountdown(prop: DetailProperty){
    this.endDate = new Date(prop.ParentPropertyValue);
    let time = this.checkDuration();

    if (time > 0){
      if (this.sub) this.sub.unsubscribe();
      if (this.sub1) this.sub1.unsubscribe();
      let timer = Observable.timer(0,1000);
      let timer2 = Observable.timer(0,5000);
      this.sub = timer.subscribe(t => this.convertTime(time - (1 * t)));
      this.sub1 = timer2.subscribe(t => this.syncDuration())
    }
    else{
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    }
  }

  checkDuration(){
    var momentCurrentDate = moment(new Date());
    if (this.headerService.getCurrentUserDateTime()){
      momentCurrentDate = this.headerService.getCurrentUserDateTime();
    }
    var momentEndDate = moment(this.endDate ? this.endDate : new Date());
    var duration = moment.duration(momentEndDate.diff(momentCurrentDate));
    var time = Math.round(duration.asSeconds());
    return time;
  }

  syncDuration(){
    let time = this.checkDuration();
    if (this.sub) this.sub.unsubscribe();
    let timer = Observable.timer(0,1000);
    this.sub = timer.subscribe(t => this.convertTime(time - (1 * t)));
  }

  handleEvent(event){
    console.log(event);
  }
  
  convertTime(seconds: number){
    if (seconds < 1398) {
      this.warning = true;
    }

    if (seconds == 0){
      if (this.sub) this.sub.unsubscribe();
      if (this.sub1) this.sub.unsubscribe();
      this.countdownEnd.emit(true);
    }
    else if (seconds < 0){
      seconds = 0;
    }

    var days = Math.floor(seconds / (3600*24));
    seconds-= days*3600*24;
    var hrs = Math.floor(seconds / 3600);
    seconds-= hrs*3600;
    var mnts = Math.floor(seconds / 60);
    seconds-= mnts*60;

    this.days = days;
    this.hours = hrs;
    this.minutes = mnts;
    this.seconds = seconds;
  }

  ngOnDestroy(){
    if (this.sub){
      this.sub.unsubscribe();
    }

    if (this.sub1){
      this.sub1.unsubscribe();
    }
  }
}
